export const configEnviroment = {

  prefix: lsConfiguration.prefix, // '/liquidsuitehomologacao/web',
  locale: lsConfiguration.locale, // 'pt-BR'
  dateFormat: lsConfiguration.dateFormat, // 'DD/MM/YYYY',
  currencyCentSeparator: lsConfiguration.currencyCentSeparator, // ',',
  licenseWebPKI: lsConfiguration.licenseWebPKI,
  dateFormatMoment: lsConfiguration.dateFormatMoment, // 'DD/MM/YYYY',
  timeFormatMoment: lsConfiguration.timeFormatMoment, // 'DD/MM/YYYY',

  // navigationRegsPage: 10,
  // searchRegsPage: 10,

  // getNavRegsPage: function () {
  //   console.log('config nav ok', _config.navigationRegsPage);
  //   return _config.navigationRegsPage;
  // },

  // getSearchRegsPage: function () {
  //   console.log('config search ok', _config.navigationRegsPage);
  //   return _config.searchRegsPage;
  // },

};
